<template>
  <card-wrapper :image="getImage" class="CouponCard" :cssClass="!immutable ? 'RewardsCardPadding' : null">
    <template v-slot:textBody>
      <div class="header">
        {{ coupon.name }}
      </div>

      <div class="subheader">
        {{ coupon.description }}
      </div>
    </template>

    <template v-slot:description>
      <template v-if="quantity">
        <span class="points" style="position: absolute; bottom: 5px">
          {{ $vuetify.lang.t('$vuetify.common.quantity') }}: {{quantity}}
        </span>
      </template>
      <template v-else-if="immutable">
        <span class="points">
          {{ $vuetify.lang.t('$vuetify.common.purchased') }}:
          {{coupon.using}}
        </span>
      </template>
      <div v-else>
        <div id="action" class="row middle-xs">
          <v-btn v-if="!coupon.using" @click="onChange(1, coupon)" color="primary" id="addBtn">
            {{ $vuetify.lang.t('$vuetify.coupon.addToCart') }} ({{ getFinalChargeFromCharges(coupon.charges) | currency(true)}})
          </v-btn>
          <template v-else>
            <attribute-quantity-selector
              :init-quantity="coupon.using || 1"
              :max-cardinality="coupon.maxInstancesPerUser || -1"
              @change="onChange($event, coupon)"
            />

            <span>
              {{ getFinalChargeFromCharges(coupon.charges) * coupon.using | currency(true)}}
            </span>
          </template>
        </div>
      </div>
    </template>
  </card-wrapper>
</template>

<script>
import { get } from 'lodash'
import { mapGetters } from 'vuex'

import CardWrapper from './CardWrapper'
import AttributeQuantitySelector from "./AttributeQuantitySelector"

export default {
  components: { CardWrapper, AttributeQuantitySelector },

  props: {
    coupon: {
      type: Object,
      required: true
    },

    immutable: {
      type: Boolean,
      default: false
    },

    quantity: {
      type: Number,
      default: 0
    }
  },

  computed: {
    getImage() {
      const url = get(this.coupon, 'imageUrl')
      if (url)
        return `${this.origin}/v1${url}`
      return null
    },

    ...mapGetters([ 'origin' ])
  },

  methods: {
    onChange(AmountSelected, coupon) {
      this.$set(coupon, 'using', AmountSelected)
      this.$emit('couponChange')
    },

    getFinalChargeFromCharges(charges = []) {
      return get(charges.find(charge => charge.promotional) || charges[0], 'value', 0)
    }
  }
}
</script>

<style>
  .RewardsCardPadding  {
    padding-bottom: 55px;
  }

  #total {
    position: absolute;
    bottom: 75px;
    left: 30px;
  }
  #action {
    position: absolute;
    bottom: 7.5px;
    left: 35px;

    height: 50px;
  }
  #action #addBtn {
    min-width: 120px !important;
  }
  #action>span {
    margin-left: 15px;
  }

  .points {
    font-size: 18px;
    font-weight: 600;
  }
</style>
